import { createContext } from "react";

export interface IPlatformSettingsContext {
    logo: string;
}

export const PlatformSettingsContext = createContext<IPlatformSettingsContext>(undefined);